<input type="file" accept=".xlsx, .xls" id="selectedFile" style="display: none;" (change)="onFileChanged($event); fileInput.value=''" #fileInput >
<div style="height: 25px; width: 25px" onclick="document.getElementById('selectedFile').click();"></div>
